import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { ConfigContext } from "../../Config/ConfigContext";
import FacebookOAuthProvider from ".";
import FacebookLogin from "./FacebookLogin";
import AuthLoadingContainer from "../AuthLoadingContainer";
import { Box } from "@mui/material";
import useApi from "../../hooks/useApi";

/**
 * FacebookOAuthChoice component that handles the Facebook OAuth choice process.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to render upon successful authentication.
 * @param {function} props.setAuthSuccess - Callback function to set the authentication success status.
 * @returns {JSX.Element} The rendered FacebookOAuthChoice component.
 */
export default function FacebookOAuthChoice(props) {
	const [fbScriptLoaded, setFbScriptLoaded] = useState(false);
	const [authSucceeded, setAuthSucceeded] = useState(false);
	const { config } = useContext(ConfigContext);
	const api = useApi();

	return (
		<FacebookOAuthProvider
			onScriptLoadSuccess={() => setFbScriptLoaded(true)}
			appId={config.facebookOAuth.appId}
		>
			{!fbScriptLoaded && <AuthLoadingContainer />}
			{authSucceeded && props.children}
			{!authSucceeded &&
				fbScriptLoaded && (
					<Box
						sx={{
							backgroundColor: "#23102E",
							width: "100%",
							height: "100%",
						}}
					>
						<FacebookLogin
							onSuccess={async ({ credentialResponse }) => {
								const params = {
									oauthResponse: JSON.stringify(credentialResponse),
									signInPlatform: "facebook",
									signInToken: credentialResponse.authResponse.accessToken
								};
								await api.auth.init({ params });
								setAuthSucceeded(true);
								props.setAuthSuccess(true);
							}}
						/>
					</Box>
				)}
		</FacebookOAuthProvider>
	);
}

FacebookOAuthChoice.propTypes = {
	children: PropTypes.node,
	setAuthSuccess: PropTypes.func.isRequired,
};
